import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconClockList12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconClockList12"
            aria-hidden="true"
            {...props}
        >
            <g fill="none">
                <g clipPath="url(#ClockList12)">
                    <path
                        fill="currentColor"
                        fillRule="evenodd"
                        d="M1 6a4 4 0 1 1 8 0 4 4 0 0 1-8 0m4-5a5 5 0 1 0 0 10A5 5 0 0 0 5 1m.5 2.5a.5.5 0 1 0-1 0v3H7a.5.5 0 1 0 0-1H5.5zm6-1.5H9.472a6 6 0 0 0-1.154-1H11.5a.5.5 0 1 1 0 1m0 3h-.583a6 6 0 0 0-.258-1h.841a.5.5 0 1 1 0 1m-.841 3q.17-.484.258-1h.583a.5.5 0 1 1 0 1zm-1.187 2a6 6 0 0 1-1.154 1H11.5a.5.5 0 1 0 0-1z"
                        clipRule="evenodd"
                    />
                </g>
                <defs>
                    <clipPath id="ClockList12">
                        <path fill="#fff" d="M0 0h12v12H0z" />
                    </clipPath>
                </defs>
            </g>
        </svg>
    );
}
export default memo(IconClockList12);
